module.exports = __webpack_public_path__ + "static/bsas011.thumb-671de3211a32e5e151cbbb27352dc126.jpg";